import { Button, Grid } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

import { useEffect, useState } from 'react';
import { FormAutoCompleteSelectDynamic } from '../../components/hook-form/form-autocomplete-select.dynamic.component';
import FormDateField from '../../components/hook-form/form-date.field.component';
import { useFormContext } from 'react-hook-form';
import { DateFormat } from '../query-builder/hooks-form-querybuilder/form-date.field.component';
import dayjs from 'dayjs';
import { workorderReportApiKeyStore } from '../../api/workorder-report-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../query-builder/hooks-form-querybuilder/form-autocomplete-multi-select.dynamic.component';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';

export const OpeationManagementFilter = () => {
 
  const { setValue } = useFormContext();
  const [fromDateName, setFromDateName] = useState<string>();
  const [toDateName, setToDateName] = useState<string>();

  const [disabledFromData, setDisabledFromDate] = useState<boolean>(false);
  const [disabledToDate, setDisabledToDate] = useState<boolean>(false);

  const handleDefault = (fromDate: any, toDate: any, dateCriteria: any, woStatus: any) => {
    setValue('dateCriteria', dateCriteria);
    setValue('fromDate', fromDate);
    setValue('toDate', toDate);
    setValue('workOrderActiveStatus', woStatus);
    setDisabledFromDate(true);
    setDisabledToDate(true);
  };
  useEffect(() => {
    handleDefault(dayjs().subtract(2, 'week').format(DateFormat.SIMPLE_DATE), dayjs().format(DateFormat.SIMPLE_DATE),
      { dateCriteriaValue: 'created', dateCriteria: 'Created' }, { statusValue: 'all', statusLabel: 'All' });
  }, [setValue]);

  const validateDateField = (status: any) => {
    setDisabledFromDate(!!status);
    setDisabledToDate(false);
    setValue('fromDate', '');
    setValue('toDate', '');
  };

  const handleStatusChange = (value: any) => {
    validateDateField(value);
    if (value?.dateCriteria !== undefined) {
      setFromDateName(`${value?.dateCriteria} From`);
      setToDateName(`${value?.dateCriteria} To`);
    } else {
      setFromDateName(`Date From`);
      setToDateName(`Date To`);
      setValue('dateCriteria', { dateCriteriaValue: 'created', dateCriteria: 'Created' });
      setValue('fromDate', dayjs().subtract(2, 'week').format(DateFormat.SIMPLE_DATE));
      setValue('toDate', dayjs().format(DateFormat.SIMPLE_DATE));
      setDisabledFromDate(true);
      setDisabledToDate(true);
    }
  };

  const handleFromDate = (date: any) => {
    setDisabledToDate(!!date);
    setValue('toDate', '');
  };

  return (
    <Grid container spacing={1}>
      <Grid item lg={1} sm={1} xl={1} xs={1}>
        <text style={{ visibility: 'hidden' }}>Filtering</text>
      </Grid>

      <Grid item xl={2.2} lg={2.2} sm={4} xs={6}>
        <FormAutoCompleteSelectDynamic
          name="dateCriteria"
          label="Date Criteria"
          onChange={handleStatusChange}
          getQueryKeyConfig={() => workorderReportApiKeyStore.getWorkOrderReportDateCriteria()}
          optionsValueKey="dateCriteriaValue"
          optionsLabelKey="dateCriteria"
        />
      </Grid>
      <Grid item xl={2} lg={2} sm={4} xs={6}>
        <FormDateField
          label={fromDateName ? fromDateName : 'Date From'}
          name="fromDate"
          onChange={handleFromDate}
          disabled={!disabledFromData}
          format={DateFormat.SIMPLE_DATE}
        />
      </Grid>
      <Grid item xl={2} lg={2} sm={4} xs={6}>
        <FormDateField
          label={toDateName ? toDateName : 'Date To'}
          name="toDate"
          disabled={!disabledToDate}
          format={DateFormat.SIMPLE_DATE}
          dateLimits={{
            minDateEnabled: true,
            minDateValue: 'fromDate',
            // maxDateEnabled: true
          }}
        />
      </Grid>

      <Grid item lg={2} sm={2} xl={2} xs={2}>
        <FormAutoCompleteMultiSelectDynamic
          name="workOrderStatusIDs"
          label="Status"
          getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderStatus('inspection')}
          optionsLabelKey="workOrderStatus"
          optionsValueKey="workOrderStatusID"
        />
      </Grid>
        <Grid item xl={2} lg={2} sm={4} xs={6}>
          <FormAutoCompleteSelectDynamic
            name="workOrderActiveStatus"
            label="Active/Inactive Work Order Status"
            dataItems={[
              { statusValue: 'all', statusLabel: 'All', isDefault: false },
              { statusValue: 'active', statusLabel: 'Active', isDefault: false },
              { statusValue: 'inactive', statusLabel: 'Inactive', isDefault: false }]}
            optionsValueKey="statusValue"
            optionsLabelKey="statusLabel"
          />
        </Grid>
      <Grid item lg={0.8} sm={0.8} xl={0.8} xs={0.8}>
        <Button type="submit" title="Filter" variant="contained" fullWidth startIcon={<FilterAltOutlinedIcon />}>
          Filter
        </Button>
      </Grid>
    </Grid>
  );
};
